import { CellClickedEvent } from "@ag-grid-community/core";
import { Router } from "@angular/router";
import { AgFns } from "./ag-fns";
import { AgStyleFns } from "./ag-style-fns";
import { LinkHelpTooltipComponent } from "./tooltip.component";

export interface NavContext {
  router: Router;
  navPath: string;
}

export class NavFns {
  static createIdCellClickedNavProps(
    field: string,
    router: Router,
    navPath: string
  ) {
    return {
      field: field,
      cellClass: AgStyleFns.getLinkCellClass(),
      onCellClicked: (event) => {
        if (event.value == null) {
          return;
        }
        const params = NavFns.buildNavIdParams(event.value);
        NavFns.navigateWithClickEvent(event, router, navPath, params);
      },
      tooltipComponent: LinkHelpTooltipComponent,
      tooltipField: field,
    };
  }

  static createCellClickedNavProps(router: Router, navPath: string) {
    return {
      cellClass: AgStyleFns.getLinkCellClass(),
      onCellClicked: (event) =>
        NavFns.navigateWithClickEvent(event, router, navPath, event.value),
    };
  }

  static createCellClickedDialogProps(
    onClick: (value: any, event?: CellClickedEvent) => void
  ) {
    return {
      cellClass: AgStyleFns.getLinkCellClass(),
      onCellClicked: (event: CellClickedEvent) => {
        if (event.value) {
          onClick(event.value, event);
        }
      },
    };
  }

  static createCellClickedCalcNavProps(
    router: Router,
    navPathFn: (event) => { navPath: string; queryParams?: any }
  ) {
    return {
      cellClass: AgStyleFns.getLinkCellClass(),
      onCellClicked: (event) => {
        const { navPath, queryParams } = navPathFn(event);
        NavFns.navigateWithClickEvent(event, router, navPath, queryParams);
      },
    };
  }

  static navigateWithClickEvent(
    event: CellClickedEvent,
    router: Router,
    navPath: string,
    queryParams: any
  ) {
    if ((event.event as PointerEvent).ctrlKey) {
      const url = router.serializeUrl(
        router.createUrlTree([navPath], queryParams)
      );
      window.open(url, "_blank");
    } else {
      router.navigate([navPath], queryParams);
    }
  }

  static buildNavIdParams(
    id: any,
    fieldName?: string,
    fieldType?: "number" | "text"
  ) {
    fieldName = fieldName ?? "id";
    const fm = AgFns.addFilterClause({}, fieldName, "number", id);
    const urlSuffix = encodeURIComponent(JSON.stringify(fm));
    const params = {
      queryParams: {
        fm: urlSuffix,
        key: id.toString(),
      },
    };
    return params;
  }
}
